<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	const { name, svgClass, styleClass }: { name: string; svgClass?: string; styleClass?: string } =
		$props();

	let icons = $state(
		Object.fromEntries(
			Object.entries(
				import.meta.glob('/src/lib/icons/*.svg', { query: '?raw', import: 'default' })
			).map(([key, value]) => {
				const filename = key.split('/').pop()!.split('.').shift();
				return [filename, value];
			})
		)
	);

	let icon = $derived.by(async () =>
		((await icons[name]()) as string).replace(/\{class\}/, svgClass || '')
	);
</script>

{#await icon then icon}
	<div class={twMerge('h-[1em] w-[1em]', styleClass)}>{@html icon}</div>
{/await}
